let audioContext: AudioContext | null = null;

const getAudioContext = (): AudioContext | null => {
  if (typeof window === 'undefined') return null;
  if (!audioContext) {
    const AudioContextCtor = window.AudioContext || (window as Window & {
      webkitAudioContext?: typeof AudioContext;
    }).webkitAudioContext;
    if (!AudioContextCtor) return null;
    audioContext = new AudioContextCtor();
  }
  return audioContext;
};

/** Browsers block sound until a user gesture; resume on first click. */
export const unlockNotificationSound = (): void => {
  const context = getAudioContext();
  if (context?.state === 'suspended') {
    void context.resume();
  }
};

/** Short two-tone pop similar to Facebook's in-app notification chime. */
export const playNotificationSound = (): void => {
  try {
    const context = getAudioContext();
    if (!context) return;

    if (context.state === 'suspended') {
      void context.resume();
    }

    const now = context.currentTime;
    const playTone = (frequency: number, start: number, duration: number) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(frequency, start);
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.12, start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(start);
      oscillator.stop(start + duration + 0.02);
    };

    playTone(880, now, 0.09);
    playTone(1175, now + 0.1, 0.12);
  } catch {
    // Autoplay or missing AudioContext — toast still shows.
  }
};
